module.exports = __webpack_public_path__ + "img/extra-card.65e41c41.png";